import { useContext, useState } from "react";
import { Alert, Box, Card, CardContent, CardHeader, CircularProgress, Container, Grid, IconButton, InputAdornment, TextField, Typography, Pagination, Button } from "@mui/material";
import logo from "../../src/assets/img/logos/logo-espol.png";
import { BusquedaKey } from "../componente/Busqueda/BusquedaKey";
import { BusquedaAutor } from "../componente/Busqueda/BusquedaAutor";
import { themePalette } from "../config/theme.config";
import { I18nContext } from "../I18nProvider";


const componentsMap: Record<"key" | "investigador", React.FC> = {
    key: BusquedaKey,
    investigador: BusquedaAutor
};


export const Busqueda: React.FC<{}> = () => {
    const context = useContext(I18nContext);
    const [activeComponent, setActiveComponent] = useState<"key" | "investigador">("key");
    const ActiveComponent = componentsMap[activeComponent];

    if (context === null) {
        throw new Error(
            "The I18n context is not initialized. Make sure you have the provider set up correctly."
        );
    }

    return (
        <Container maxWidth="lg" style={{ padding: "20px", textAlign: "center" }}>
            <Box>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid item xs={12} sm={10} md={10} container spacing={2} justifyContent="center" alignItems="center">
                        <Grid item xs={10} sm={6} md={6}>
                            <img src={logo} alt="Logo" style={{ width: '100%', height: 'auto' }} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    spacing={2}
                    sx={{ padding: "20px" }}
                >
                    <Grid item xs={12} sm={2} md={2}>
                        <Button
                            fullWidth
                            onClick={() => setActiveComponent("key")}
                            variant="outlined"
                            sx={{
                                color:
                                    activeComponent === "key"
                                        ? "white !important"
                                        : themePalette.NAVCOLOR,
                                backgroundColor:
                                    activeComponent === "key"
                                        ? themePalette.NAVCOLOR
                                        : "transparent",
                                borderColor: themePalette.NAVCOLOR,
                            }}
                        >
                            {context.t.translate("busqueda.key")}
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={2} md={2}>
                        <Button
                            fullWidth
                            onClick={() => setActiveComponent("investigador")}
                            variant="outlined"
                            sx={{
                                color:
                                    activeComponent === "investigador"
                                        ? "white !important"
                                        : themePalette.NAVCOLOR,
                                backgroundColor:
                                    activeComponent === "investigador"
                                        ? themePalette.NAVCOLOR
                                        : "transparent",
                                borderColor: themePalette.NAVCOLOR,
                            }}
                        >
                            {context.t.translate("busqueda.autor")}
                        </Button>
                    </Grid>
                </Grid>
                <Box sx={{ marginTop: "20px" }}>
                    {ActiveComponent && (
                        <>
                            {activeComponent === "key" ? (
                               
                                    <ActiveComponent/>
                                
                            ) : activeComponent === "investigador" ?( 
                                
                                    <ActiveComponent />
                                
                            ) : null}
                        </>
                    )}
                </Box>
            </Box>    
        </Container>
    );
};
